import React from 'react';

interface Props {
  pendingCount: number;
  onConfirm: () => void;
  onGoToWorkstream: () => void;
}

const IconWarning = (
  <svg viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="1.5"
    strokeLinecap="round" strokeLinejoin="round" width={24} height={24}>
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

const LogoutConfirmModal: React.FC<Props> = ({ pendingCount, onConfirm, onGoToWorkstream }) => (
  <div style={{
    position: 'fixed', inset: 0, zIndex: 9999,
    background: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '20px',
  }}>
    <div style={{
      background: '#fff', borderRadius: 14, width: '100%', maxWidth: 460,
      boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
      overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        background: '#fffbeb', borderBottom: '1px solid #fde68a',
        padding: '18px 28px', display: 'flex', alignItems: 'center', gap: 12,
      }}>
        {IconWarning}
        <div>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#92400e' }}>
            Outstanding Workstream Actions
          </h2>
          <p style={{ margin: '2px 0 0', fontSize: 12, color: '#b45309', fontWeight: 500 }}>
            {pendingCount} item{pendingCount !== 1 ? 's' : ''} awaiting review
          </p>
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: '24px 28px' }}>
        <p style={{ margin: '0 0 28px', fontSize: 14, color: '#374151', lineHeight: 1.65 }}>
          You have{' '}
          <strong style={{ color: '#002060' }}>
            {pendingCount} outstanding action{pendingCount !== 1 ? 's' : ''}
          </strong>{' '}
          in the Workstream awaiting review. Are you sure you want to log out?
        </p>

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={onGoToWorkstream}
            style={{
              flex: 1, padding: '11px 0',
              border: '2px solid #002060', borderRadius: 8,
              background: 'transparent', color: '#002060',
              fontWeight: 700, fontSize: 13.5, cursor: 'pointer',
            }}
          >
            Go to Workstream
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1, padding: '11px 0',
              border: '2px solid #dc2626', borderRadius: 8,
              background: '#dc2626', color: '#fff',
              fontWeight: 700, fontSize: 13.5, cursor: 'pointer',
            }}
          >
            Log Out Anyway
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default LogoutConfirmModal;
